import { Fragment } from 'react'
import { NextBtn, PrevBtn } from '../../../../widgets/AppBtn';
import { fetchDataFromApi } from '../../../../widgets/api';

const LibraryFilterListView = ({onBookList, setOnBookList}) => {
    return (
        <Fragment>
            <div className='bg-white p-2 dark:bg-slate800'>
                <h3 className='font-public-sans underline underline-offset-2 text-green-500'>Total Book: <i>{onBookList?.results?.total_count || 0}</i></h3>
                <div className="relative overflow-x-auto h-[70vh] overflow-y-auto">
                    <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                        <thead className="text-[12px] text-gray700 bg-gray300  capitalize border-b dark:bg-slate900 dark:text-gray-400 font-public-sans">
                            <tr>
                                <th scope="col" align='center' className="px-2 py-1.5 top-0 sticky z-0 bg-gray-100 border dark:border-slate600 w-10">
                                    {"S.N."}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Book Name"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Book ID"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Program"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Year/Semester"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Book Author"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Book Publications"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Edition"}
                                </th>
                                <th scope="col" className="px-2 py-1.5 border top-0 sticky z-0 bg-gray-100 dark:border-slate600">
                                    {"Registration Date"}
                                </th>
                            </tr>
                        </thead>
                        <tbody className='text-slate-800'>
                            {Array.isArray(onBookList?.results?.results) && onBookList?.results?.results?.length > 0 ? (
                                onBookList?.results?.results?.map((cate, index) => (
                                    <tr key={index} className="odd:bg-white text-[12px] text-gray600 dark:text-gray-400 odd:dark:bg-slate800 even:bg-gray-50 even:dark:bg-slate700 border-b font-public-sans dark:border-gray-700">
                                        <td align='center' className="px-2 py-1 border dark:border-slate600  ">
                                            {index + 1}.
                                        </td>
                                        <td className="px-2 py-1 border dark:border-slate600 capitalize">
                                            {cate?.book_name}
                                        </td>
                                        <td align='left' className="px-2 py-1 border capitalize dark:border-slate600 ">
                                            {cate?.book_id}
                                        </td>
                                        <td align='left' className="px-2 py-1 border capitalize dark:border-slate600 ">
                                            {cate?.program_name}
                                        </td>
                                        <td align='left' className="px-2 py-1 border capitalize dark:border-slate600 ">
                                            {cate?.year_semester_name}
                                        </td>
                                        <td align='left' className="px-2 py-1 border dark:border-slate600 ">
                                            {cate?.book_author}
                                        </td>
                                        <td align='left' className="px-2 py-1 border dark:border-slate600 ">
                                            {cate?.book_publisher}
                                        </td>
                                        <td align='left' className="px-2 py-1 border dark:border-slate600 ">
                                            {cate?.edition}
                                        </td>
                                        <td align='left' className="px-2 py-1 border capitalize dark:border-slate600 ">
                                            {cate?.reg_date_n}
                                        </td>
                                    </tr>
                                ))) :
                                <tr className="odd:bg-white text-[12px] text-gray600 dark:text-gray-400 odd:dark:bg-slate800 even:bg-gray-50 even:dark:bg-slate700 border-b font-public-sans dark:border-gray-700">
                                    <td align='center' colSpan={10} className="px-2 py-1 border dark:border-slate600  ">
                                        <span>No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='flex gap-3 mt-3 justify-end'>
                <PrevBtn disabled={onBookList?.previous === null ? true : false} onClick={async () => {
                    if (onBookList?.previous) {
                        const res = await fetchDataFromApi(onBookList?.previous);
                        setOnBookList(res);
                    }
                }} />
                <NextBtn disabled={onBookList?.next === null ? true : false} onClick={async () => {
                    if (onBookList?.next) {
                        const res = await fetchDataFromApi(onBookList?.next);
                        setOnBookList(res);
                    }
                }} />

            </div>
        </Fragment>
    )
}

export default LibraryFilterListView